import type { WorkflowInstanceState, WorkflowSummary } from '../../../api/areas/registry';

/** The readable name of what a workflow acts on (today: the domain name). */
export const resourceName = (w: Pick<WorkflowSummary, 'resource_name' | 'domain_name'>): string | null =>
  w.resource_name ?? w.domain_name;

/**
 * `workflow.workflows.state` values in display order. Labels live in the `ops`
 * namespace (`workflowState.*`), tones in `WORKFLOW_TONE` (../shared).
 */
export const WF_STATES: WorkflowInstanceState[] = ['PENDING', 'RUNNING', 'WAITING', 'RETRYING', 'COMPLETED', 'FAILED', 'MANUAL_REVIEW', 'CANCELLED'];
